import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect, useState } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIModal from 'UIComponents/dialog/UIModal';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { tracker } from '../../../common/eventTracking/tracker';
import { handleSubmitSurveyResponses } from '../../../utils/tx120SurveySubmit';
import { upgradeProductSurveyResponseMap } from '../../SurveyResponses';
import { FeatureSurveyModalHeader } from './FeatureSurveyModalHeader';
import FeatureSurveyRow from './FeatureSurveyRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeatureSurveyModal = ({
  apiName,
  setInitialSuccessModal,
  upgradeData
}) => {
  const [allFeatures, setSelectedFeatures] = useState(upgradeProductSurveyResponseMap[apiName]);
  const [isOtherSelected, setIsOtherSelected] = useState(false);
  const isDisabled = Object.values(allFeatures).every(isSelected => !isSelected);
  useEffect(() => {
    tracker.track('trialActivationInteraction', Object.assign({
      action: 'viewed pricing page survey modal'
    }, upgradeData));
  }, [upgradeData]);
  const handleSubmitSelectedFeatures = async () => {
    if (isOtherSelected) {
      tracker.track('trialActivationInteraction', Object.assign({
        action: 'selected other'
      }, upgradeData));
    }
    await handleSubmitSurveyResponses(apiName, allFeatures, upgradeData);
    setInitialSuccessModal();
  };
  const handleSkip = () => {
    tracker.track('trialActivationInteraction', Object.assign({
      action: 'survey skipped'
    }, upgradeData));
    setInitialSuccessModal();
  };
  const featureKeys = Object.keys(allFeatures);
  const handleSelectedFeatureChange = (featureKey, isSelected) => {
    if (featureKey === 'other') {
      setIsOtherSelected(isSelected);
      return;
    }
    const newSelectedFeatures = Object.assign({}, allFeatures, {
      [featureKey]: isSelected
    });
    setSelectedFeatures(newSelectedFeatures);
  };
  const renderTwoRows = () => {
    const firstRowFeatureKeys = featureKeys.slice(0, 3);
    const secondRowFeatures = featureKeys.slice(3);
    secondRowFeatures.push('other');
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FeatureSurveyRow, {
        className: "m-bottom-5",
        survey: allFeatures,
        featureKeys: firstRowFeatureKeys,
        onSelectionChange: handleSelectedFeatureChange
      }, 1), /*#__PURE__*/_jsx(FeatureSurveyRow, {
        survey: allFeatures,
        featureKeys: secondRowFeatures,
        isOtherSelected: isOtherSelected,
        onSelectionChange: handleSelectedFeatureChange
      }, 2)]
    });
  };
  const renderThreeRows = () => {
    const firstRowFeatureKeys = featureKeys.slice(0, 3);
    const secondRowFeatures = featureKeys.slice(3);
    const lastRow = ['other'];
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FeatureSurveyRow, {
        className: "m-bottom-5",
        survey: allFeatures,
        featureKeys: firstRowFeatureKeys,
        onSelectionChange: handleSelectedFeatureChange
      }, 1), /*#__PURE__*/_jsx(FeatureSurveyRow, {
        className: "m-bottom-5",
        survey: allFeatures,
        featureKeys: secondRowFeatures,
        onSelectionChange: handleSelectedFeatureChange
      }, 2), /*#__PURE__*/_jsx(FeatureSurveyRow, {
        className: "m-bottom-8",
        survey: allFeatures,
        featureKeys: lastRow,
        isOtherSelected: isOtherSelected,
        onSelectionChange: (__key, value) => setIsOtherSelected(value)
      }, 3)]
    });
  };
  const renderFeatureRows = () => {
    // Render 3 rows of box buttons if there are 6 features for that api name.
    if (featureKeys.length === 6) {
      return renderThreeRows();
    }
    return renderTwoRows();
  };
  return /*#__PURE__*/_jsxs(UIModal, {
    use: "success",
    width: 600,
    size: "auto",
    centered: true,
    children: [/*#__PURE__*/_jsx(FeatureSurveyModalHeader, {}), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [/*#__PURE__*/_jsx("p", {
        className: "text-center",
        style: {
          fontWeight: 'bold'
        },
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.trialFeatureSurvey.common.headline"
        })
      }), renderFeatureRows()]
    }), /*#__PURE__*/_jsx(UIDialogFooter, {
      children: /*#__PURE__*/_jsxs(UIFlex, {
        align: "center",
        direction: "column",
        gap: 16,
        className: "m-all-0 m-top-2",
        children: [/*#__PURE__*/_jsx(UITooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.trialFeatureSurvey.common.tooltip"
          }),
          disabled: !isDisabled,
          children: /*#__PURE__*/_jsx(UIButton, {
            use: "primary",
            onClick: () => {
              handleSubmitSelectedFeatures().catch(() => {});
            },
            disabled: isDisabled,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "upgrades.trialFeatureSurvey.common.submitButton"
            })
          })
        }), /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          onClick: handleSkip,
          className: "m-all-0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.trialFeatureSurvey.common.skipButton"
          })
        })]
      })
    })]
  });
};
export default FeatureSurveyModal;